import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import SalonContextSwitcher from '../../components/ui/SalonContextSwitcher';
import TabNavigation from './components/TabNavigation';
import EmployeeManagement from './components/EmployeeManagement';
import ServiceManagement from './components/ServiceManagement';
import AvailabilityCalendar from './components/AvailabilityCalendar';
import ServerStatus from 'components/ui/ServerStatus';
import ClientManagement from './components/ClientManagement';

const SalonManagement = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedSalon, setSelectedSalon] = useState(
    '68c806bf374b8c596edb208c'
  ); // real salonId
  const [activeTab, setActiveTab] = useState(() => {
    if (window.location.pathname === '/service-management') return 'services';
    if (window.location.pathname === '/availability-calendar') return 'calendar';
    return 'employees';
  });

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  const handleSalonChange = (salonValue) => {
    setSelectedSalon(salonValue);
  };

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'employees':
        return <EmployeeManagement selectedSalon={selectedSalon} />;
      case 'services':
        return <ServiceManagement selectedSalon={selectedSalon} />;
      case 'calendar':
        return <AvailabilityCalendar selectedSalon={selectedSalon} />;
      case 'client':
        return <ClientManagement selectedSalon={selectedSalon} />;
      default:
        return <EmployeeManagement selectedSalon={selectedSalon} />;
    }
  };

  return (
    <div className="min-h-screen bg-background" dir="rtl">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={handleSidebarClose} />

      {/* Header */}
      {/* <Header onToggleSidebar={handleSidebarToggle} /> */}

      {/* Main Content */}
      <main className="lg:mr-60 pt-16">
        <div className="p-6 space-y-6">
          {/* Breadcrumb Navigation */}
          <BreadcrumbNavigation />

          {/* Page Header */}
          <div className="flex flex-col lg:flex-row gap-6">
            <div className="flex-1">
              <div className="mb-6">
                <h1 className="text-2xl font-bold text-foreground mb-2">
                  مدیریت سالن
                </h1>
                <p className="text-muted-foreground">
                  مدیریت جامع عملیات سالن شامل کارکنان، خدمات و برنامه‌ریزی
                </p>
              </div>

              {/* Tab Navigation */}
              <div className="mb-6">
                <TabNavigation
                  activeTab={activeTab}
                  onTabChange={handleTabChange}
                />
              </div>

              {/* Tab Content */}
              <div className="bg-background">{renderTabContent()}</div>
            </div>

            {/* Sidebar Context */}
            {/* <div className="lg:w-80 space-y-6">

              <div className="bg-card border border-border rounded-lg p-4">
                <h3 className="text-sm font-medium text-foreground mb-3">
                  انتخاب سالن
                </h3>
                <SalonContextSwitcher
                  selectedSalon={selectedSalon}
                  onSalonChange={handleSalonChange}
                />
              </div>


              <div className="bg-card border border-border rounded-lg p-4">
                <h3 className="text-sm font-medium text-foreground mb-4">
                  آمار سریع
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-muted-foreground">
                      کل کارکنان
                    </span>
                    <span className="text-sm font-medium text-foreground">
                      ۸ نفر
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-muted-foreground">
                      خدمات فعال
                    </span>
                    <span className="text-sm font-medium text-foreground">
                      ۱۵ خدمت
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-muted-foreground">
                      رزروهای امروز
                    </span>
                    <span className="text-sm font-medium text-success">
                      ۲۴ رزرو
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-muted-foreground">
                      درآمد هفته
                    </span>
                    <span className="text-sm font-medium text-foreground">
                      ۱۲,۵۰۰,۰۰۰ تومان
                    </span>
                  </div>
                </div>
              </div>


              <div className="bg-card border border-border rounded-lg p-4">
                <h3 className="text-sm font-medium text-foreground mb-4">
                  فعالیت‌های اخیر
                </h3>
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-success rounded-full mt-2 flex-shrink-0"></div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs text-foreground">
                        مریم احمدی خدمت جدید اضافه کرد
                      </p>
                      <p className="text-xs text-muted-foreground">
                        ۲ ساعت پیش
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-warning rounded-full mt-2 flex-shrink-0"></div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs text-foreground">
                        برنامه کاری فاطمه کریمی تغییر کرد
                      </p>
                      <p className="text-xs text-muted-foreground">
                        ۴ ساعت پیش
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs text-foreground">
                        خدمت جدید "ماساژ درمانی" اضافه شد
                      </p>
                      <p className="text-xs text-muted-foreground">۱ روز پیش</p>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </main>
    </div>
  );
};

export default SalonManagement;
